function debounceFacets(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounceFacets((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Add click handler for labels
    facetForm.addEventListener('click', (event) => {
      if (event.target.tagName === 'LABEL' || event.target.closest('label')) {
        const checkbox = event.target.querySelector('input[type="checkbox"]') ||
          event.target.closest('label').querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  // Before re-rendering, record the state
  static getActiveFacetsState() {
    const activeFacetsState = {};
    document.querySelectorAll('.js-filter').forEach((facet) => {
      activeFacetsState[facet.dataset.index] =
        facet.classList.contains('active');
    });
    return activeFacetsState;
  }

  // After re-rendering, restore the state
  static setActiveFacetsState(state) {
    for (let index in state) {
      const facet = document.querySelector(`.js-filter[data-index="${index}"]`);
      if (facet) {
        facet.classList.toggle('active', state[index]);
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true,
    isClear = false,
  ) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById(
      'ProductCountDesktop',
    );
    const savedState = FacetFiltersForm.getActiveFacetsState();
    document.body.classList.add('sa-facets--loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, isClear)
        : FacetFiltersForm.renderSectionFromFetch(url, event, isClear);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    // $('.filter__section-title').on('click', function () {
    //   $(this).closest('.filter__section').toggleClass('active');
    // });
    // FacetFiltersForm.setActiveFacetsState(savedState);
    if (!isClear) {
      FacetFiltersForm.setActiveFacetsState(savedState);
    }
  }

  static renderSectionFromFetch(url, event, isClear = false) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event, isClear);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, isClear = false) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, isClear);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById(
      'product-grid-container',
    );
    if (productGridContainer) {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const innerElement = parsedHtml.getElementById('product-grid-container');
      if (innerElement) {
        productGridContainer.innerHTML = innerElement.innerHTML;
      }
    }

    document.body.classList.remove('sa-facets--loading');

    if (window.indentGridProducts) {
      indentGridProducts();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;

    $('.js-filters-count').html(count);

    document.body.classList.remove('sa-facets--loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      document.body.classList.remove('sa-facets--loading');
    }
  }

  static renderFilters(html, event, isClear = false) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    console.log('isClear', isClear);
    if (isClear) {
      console.log('isClear', isClear);
      const isMobile = window.innerWidth < 768;

      facetDetailsElements.forEach((element) => {
        const targetElement = document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`,
        );
        if (targetElement) {
          targetElement.innerHTML = element.innerHTML;
          // On mobile, keep sections active (visible), on desktop remove active (close accordions)
          if (!isMobile) {
            targetElement.classList.remove('active');
          } else {
            // On mobile, ensure active class is present and items are visible
            targetElement.classList.add('active');
            const itemsWrapper = targetElement.querySelector('.filter__items-wrapper');
            if (itemsWrapper) {
              itemsWrapper.style.display = 'block';
            }
          }
        }
      });
    }

    window?.initFiltersSwiper?.();
    FacetFiltersForm.displayActiveFilterSections();
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter'),
      );

    const filtersCount = $('.sa-facets__form input:checked').length;

    $('.js-filters-applied').text(filtersCount > 0 ? `${filtersCount}` : '');
    $('.js-filters-text').text(filtersCount === 1 ? `Filter` : 'Filters');
  }

  static displayActiveFilterSections() {
    let activeSections = document.querySelectorAll('.filter__section.active');

    activeSections.forEach(function (section) {
      let itemsWrapper = section.querySelector('.filter__items-wrapper');

      if (itemsWrapper) {
        itemsWrapper.style.display = 'block';
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById('FacetFiltersFormMobile')
      ?.closest('menu-drawer')
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  // static getSections() {
  //   return [
  //     {
  //       section: document.getElementById('product-grid').dataset.id,
  //     },
  //   ];
  // }

  static getSections() {
    const sections = [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];

    // Check if filters are in a separate section (like in materials template)
    const filtersForm = document.getElementById('FacetFiltersForm');
    if (filtersForm) {
      const filtersSection = filtersForm.closest('[data-section-id]') ||
        filtersForm.closest('[id*="shopify-section"]');
      if (filtersSection) {
        const filtersSectionId = filtersSection.getAttribute('data-section-id') ||
          filtersSection.id.replace('shopify-section-', '');
        const productGridSectionId = document.getElementById('product-grid').dataset.id;

        // Only add if it's a different section
        if (filtersSectionId && filtersSectionId !== productGridSectionId) {
          sections.push({
            section: filtersSectionId
          });
        }
      }
    }

    return sections;
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    console.log('form submit');
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form',
    );
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form'),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      // const isMobile =
      //   event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
        if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event, isClear = false) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf('?') + 1,
        );
    FacetFiltersForm.renderPage(url, null, true, isClear);
  }
}
// FacetFiltersForm.displayActiveFilterSections();
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event, true);
  }
}

customElements.define('facet-remove', FacetRemove);

// $('.js-filter-count').html( $('#ProductCount').html() );

document.addEventListener('click', (event) => {
  console.log('click', event);
});